<script>
import config from "../../config";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import pagination from "laravel-vue-pagination";
import { customerService } from "../../services";
import { error_message, success_message, debounce } from "../../Helper/helper";

export default {
  components: { pagination, Layout, PageHeader },
  data() {
    const { status, type, orderBy, sortBy } = this.$route.query;
    return {
      config: config,
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      customers: [],
      customerData: [],
      // customerCount: "",
      paginations: {},
      limit: 2,
      search: "",
      status: status == undefined ? "0" : status,
      type: type || "1",
      loading: true,
      isDownloading: false,
      fields: [
        {
          key: "unique",
          label: this.trans.get("__JSON__.Customer ID"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "user_name",
          label: this.trans.get("__JSON__.Name"),
          sortable: true,
        },
        {
          key: "email",
          label: this.trans.get("__JSON__.Email"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "mobile_number",
          label: this.trans.get("__JSON__.Customer Number"),
          sortable: true,
        },

        {
          key: "user_role",
          label: this.trans.get("__JSON__.Customer Type"),
          sortable: false,
          thClass:"dis-event"
        },

        {
          key: "total_credit",
          label: this.trans.get("__JSON__.Total Credit"),
          sortable: true,
        },
        {
          key: "payment_method",
          label: this.trans.get("__JSON__.Payment Method"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "paybackrequest",
          label: this.trans.get("__JSON__.Payback Requests"),
          sortable: true,
        },
        {
          key: "action",
          label: this.trans.get("__JSON__.Action"),
          sortable: false,
          thClass:"dis-event"
        },
      ],
      searchData: debounce(() => {
        const { status, type, orderBy, sortBy } = this.$data;
        this.$router.replace({
          name: "customer-credit-list",
          query: { status, type, orderBy, sortBy },
        });
        this.getCustomerCreditList();
      }, 500),
    };
  },
  mounted() {
    //this.getCustomerCreditList();
    //awailt get-customer-credit =
    this.getCustomerCreditList();
  },
  methods: {
    onRowClicked(item) {
      this.$router.push({
        name: "customer-credit-detail",
        params: { user_id: this.base64(item.user_id) },
      });
    },
    async getCustomerCreditList(page) {
      this.loading = true;
      var filters = {
        search: this.search,
        status: this.status,
        type: this.type,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
      };
      var url = config.api_url + "get-customer-credit";
      var response = await window.axios.post(url, filters);
      this.loading = false;
      this.paginations = response.data.result.data;
      this.customers = response.data.result.data.data;
      // this.customerCount = response.data.result.customerCount;
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getCustomerCreditList();
    },
  },
};
</script>

<template>
  <Layout>
    <div>
      <div class="row">
        <div class="col-12">
          <div
            class="
              page-title-box
              d-flex
              align-items-center
              justify-content-between
              icon-main-page
            "
          >
            <div class="page-title-left">
              <div class="avatar-xs mr-3">
                <span
                  class="
                    avatar-title
                    rounded-circle
                    bg-soft-primary
                    text-primary
                    font-size-18
                  "
                >
                  <i class="bx bx-user-circle"></i>
                </span>
              </div>
              <h4 class="mb-0 font-size-18">
                {{ trans.get("__JSON__.Credit") }}
              </h4>
            </div>
            <div class="page-title-right d-flex">
              <!-- <router-link :to="{name: 'customer-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.get('__JSON__.Add Customer') }}
            </router-link>
            <button
              @click="customerExportCsv"
              class="btn btn-primary btn-rounded export-btn"
              v-if="isDownloading"
              disabled
            >{{ trans.get('__JSON__.Exporting...') }}</button>
            <button
              @click="customerExportCsv"
              class="btn btn-primary btn-rounded export-btn"
              v-else
            >{{ trans.get('__JSON__.Export To CSV') }}</button>
            <button
              @click="customerExportCsv"
              class="btn btn-primary btn-rounded m-export-btn"
            ><i class="bx bx-archive-in"></i></button> -->
            </div>
          </div>
        </div>
      </div>
      <div class="row list-table-main">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3 offset-sm-6">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{ trans.get("__JSON__.Customer Type") }} :</label>
                      <select
                        class="custom-select"
                        v-model="type"
                        @change="searchData()"
                      >
                        <option value="" selected>
                          {{ trans.get("__JSON__.All") }}
                        </option>
                        <option value="5">
                          {{ trans.get("__JSON__.Business") }}
                        </option>
                        <option value="1">
                          {{ trans.get("__JSON__.Private") }}
                        </option>
                        
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="date-range-list">
                    <label>{{ trans.get("__JSON__.Search") }} :</label>
                    <div class="text-sm-right">
                      <div class="search-box mr-2 d-inline-block">
                        <div class="position-relative">
                          <input
                            type="text"
                            class="form-control"
                            id="search"
                            @input="searchData()"
                            v-model="search"
                            :placeholder="
                              trans.get('__JSON__.Search Placeholder')
                            "
                          />
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="
                    col-12
                    table-main-list
                    customer-table
                    table-responsive
                    cust_tbl
                  "
                >
                  <b-table
                    :items="customers"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="sortingChanged"
                    :no-local-sorting="true"
                    :busy="loading"
                    show-empty
                    @row-clicked="onRowClicked"
                  >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
                      </div>
                    </template>

                    <template v-slot:cell(unique)="data">
                      <h5 class="font-size-14">{{ data.item.unique }}</h5>
                    </template>

                    <template v-slot:cell(payment_method)="data">
                      <h5 class="font-size-14">
                        {{
                          data.item.payment_method
                            ? data.item.payment_method
                            : "-"
                        }}
                      </h5>
                    </template>

                    <template v-slot:cell(user_name)="data">
                      <h5 class="font-size-14">
                        {{ data.item.user_name }} {{ data.item.last_name }}
                      </h5>
                    </template>

                    <!-- <template v-slot:cell(user_role)="data">
                      <div
                        v-if="data.item.user_role === '1'"
                        class="badge badge-pill badge-soft-danger font-size-12"
                      >
                        {{ trans.get("__JSON__.Private") }}
                      </div>
                      <div
                        v-if="data.item.user_role === '5'"
                        class="badge badge-pill badge-soft-success font-size-12"
                      >
                        {{ trans.get("__JSON__.Business") }}
                      </div>
                    </template> -->

                    <template v-slot:cell(status)="data">
                      <div
                        v-if="data.item.status === '1'"
                        class="badge badge-pill badge-soft-danger font-size-12"
                      >
                        {{ trans.get("__JSON__.Inactive") }}
                      </div>
                      <div
                        v-else
                        class="badge badge-pill badge-soft-success font-size-12"
                      >
                        {{ trans.get("__JSON__.Active") }}
                      </div>
                    </template>

                    <template v-slot:cell(action)="data">
                      <b-dropdown
                        lazy
                        id="dropdown-1"
                        variant="link"
                        right
                        role="navigation"
                        class="m-md-2"
                      >
                        <template #button-content>
                          <i class="bx bx-dots-vertical-rounded"></i>
                        </template>
                        <b-dropdown-item
                          :to="{
                            name: 'customer-credit-detail',
                            params: { user_id: base64(data.item.user_id) },
                          }"
                        >
                          View
                        </b-dropdown-item>
                      </b-dropdown>

                      <!-- <button
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="deleteById(base64(data.item.user_id))"
                    >{{ trans.get('__JSON__.Delete') }}</button>
                    <button v-if="data.item.status == 0 || data.item.status == 1"
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="blockById(base64(data.item.user_id))"
                    >{{ trans.get('__JSON__.Block') }}</button>
                    <button v-if="data.item.status == 3"
                      type="submit"
                      class="btn btn-success btn-sm btn-rounded ml-1"
                      @click="unblockById(base64(data.item.user_id))"
                    >{{ trans.get('__JSON__.Unblock') }}</button> -->
                    </template>

                    <template #empty>
                      <p class="text-center">
                        {{ trans.get("__JSON__.No Customer") }}
                      </p>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getCustomerCreditList"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>